"use client";

import { PrivyProvider } from "@privy-io/react-auth";
import { ReactNode } from "react";
import { base } from "viem/chains";
import { SmartWalletsProvider } from "@privy-io/react-auth/smart-wallets";

// Define the props type for the Providers component
interface ProvidersProps {
  children: ReactNode;
}

export default function Providers({ children }: ProvidersProps) {
  // Ensure environment variables are defined
  const appId = import.meta.env.VITE_PRIVY_APPID;
  const clientId = import.meta.env.VITE_PRIVY_CLIENTID;
 console.log(base)
  if (!appId || !clientId) {
    throw new Error(
      "Privy appId or clientId is not defined. Please set NEXT_PUBLIC_PRIVY_APPID and NEXT_PUBLIC_PRIVY_CLIENTID in your environment variables."
    );
  }

  return (
    <PrivyProvider
      appId={appId}
      config={{
        supportedChains: [base],
        appearance: {
          accentColor: "#62E85F",
          showWalletLoginFirst: true,
          landingHeader: "Welcome to PayzTap",
          theme: "light",
          logo: "/logo.png",
          walletChainType: "ethereum-only",
        },
        embeddedWallets: {
          showWalletUIs: false,
          ethereum: {
            createOnLogin: "users-without-wallets",
          },
        },
        defaultChain: base,
      }}
    >
      <SmartWalletsProvider>{children}</SmartWalletsProvider>
    </PrivyProvider>
  );
}
